<template>
  <ApiPlaygroundView pageType="edit_request" :valueProps="client" />
</template>
<script>
import { UseAppStore } from '@/stores/AppStore';
import ApiPlaygroundView from "@/views/admin/api-playground/View";
import APIDataService from "@/services/APIDataService";
import ErrorHandler from "@/ErrorHandler";

export default {
  setup() {
    const appStore = UseAppStore();
    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("api-requests", "API Request", "/admin/api-requests")
    return {
      appStore
    }
  },
  created() {
    this.getClient()
  },
  data() {
    return {
      client: {}
    }
  },
  components: {
    ApiPlaygroundView
  },
  methods: {
    getClient() {
      APIDataService.playground(this.$route.params.id)
        .then(response => {
          this.client = response.data['data']['api_data']
          console.log(response.data)
        })
        .catch(e => {
          ErrorHandler(e)
        });
    }
  }
};
</script>
